const backToTopHandler = () => {
    let button = document.querySelector(".to-top");
    let heightToShow = 1000;

    let showButton = () => {
        button.style.display = "block";
    }

    let hideButton = () => {
        button.style.display = "none";
    }

    window.addEventListener("scroll", (event) => {
        scrollY > heightToShow ? showButton() : hideButton();
    });
}

export default backToTopHandler;